import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Title } from 'components/layout'
import { Button } from 'components/misc'
import { apiCodeLists, apiLabels } from 'helpers/decorators/api'
import { form, permissions } from 'helpers/decorators'
import { createValidate } from 'models/labels'
import { Checkbox, Input, Select, Textarea } from '../../../../components/fields'
import { get } from 'lodash'
import { LABELS_TYPES, ORGANIZATION_HIERARCHY, ROLES } from 'constants/enums'

@apiLabels()
@permissions()
@apiCodeLists(['labelTypes'])
@form({
  form: 'create-label-form',
  disableHook: true,
  validate: createValidate
})
class LabelCreate extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onCreateLabel: PropTypes.func.isRequired,
    isPersonLabelsEnabled: PropTypes.bool,
    isContactLabelsEnabled: PropTypes.bool,
    isOrgLabelsEnabled: PropTypes.bool,
    permissions: PropTypes.object,
    isAwardLabelsEnabled: PropTypes.bool,
    values: PropTypes.object,
    initialize: PropTypes.func.isRequired
  }

  filterLabelTypes = labelTypesList => {
    const { isPersonLabelsEnabled, isContactLabelsEnabled, isOrgLabelsEnabled, isAwardLabelsEnabled } = this.props

    if(labelTypesList){

      if(!isPersonLabelsEnabled){
        labelTypesList = labelTypesList.filter(l => get(l, 'value') !== LABELS_TYPES.person.id)
      }

      if(!isContactLabelsEnabled){
        labelTypesList = labelTypesList.filter(l => get(l, 'value') !== LABELS_TYPES.contact.id)
      }

      if(!isOrgLabelsEnabled){
        labelTypesList = labelTypesList.filter(l => get(l, 'value') !== LABELS_TYPES.organization.id)
      }

      if(!isAwardLabelsEnabled){
        labelTypesList = labelTypesList.filter(l => get(l, 'value') !== LABELS_TYPES.award.id)
      }
    }

    return labelTypesList
  }

  changeCategory = value => {
    if(get(value, 'value') === LABELS_TYPES.contact.id || get(value, 'value') === LABELS_TYPES.organization.id){
      const initObj = {
        ...this.props.values,
        isReserved: false
      }

      this.props.initialize(initObj)
    }
  }

  render() {
    const {
      handleSubmit,
      onCreateLabel,
      onClose,
      submitting,
      codeLists,
      activeOrganization,
      values,
      permissions: appPermission
    } = this.props

    let labelTypesList = this.filterLabelTypes(get(codeLists, 'labelTypes.list'))

    const isAU = get(activeOrganization, 'hierarchyLevelType.value') === ORGANIZATION_HIERARCHY.AU.value ||
        get(activeOrganization, 'hierarchyLevelType.value') === ORGANIZATION_HIERARCHY.IAC.value

    if (isAU) {
      labelTypesList = labelTypesList.filter(l => get(l, 'value') === LABELS_TYPES.person.id || get(l, 'value') === LABELS_TYPES.award.id)
    }

    const orgId = get(activeOrganization, 'id')

    const permittedReservedOption =  get(values, 'category') && (get(values, 'category') !== LABELS_TYPES.contact.id && get(values, 'category') !== LABELS_TYPES.organization.id)

    return (
      <Form onSubmit={handleSubmit(fields => onCreateLabel(orgId, fields))} >
        <Title h3 intlKey="label.create_new_label">
          Create new label
        </Title>

        <div className="row">
          <div className="col-xs-6">
            <Input
                label="Name"
                intlKey="label.name"
                name="name"
            />
          </div>
        </div>
          <div className="row">
            <div className="col-xs-6">
              <Textarea label="Description" intlKey="label.description" name="description" />
            </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Select
                label="Category"
                intlKey="label.category"
                name="category"
                options={labelTypesList}
                onSelectChange={value => this.changeCategory(value)}
            />
          </div>
        </div>
        {appPermission.activeRole !== ROLES.LEADER.u && <div className="row">
        <div className="col-xs-6">
          <Checkbox
            label="The label can be used only by this organization. (Organizations below cannot see, use, or delete this label)"
            intlKey="label.reserved_for_organization"
            name="isReserved"
            disabled={!permittedReservedOption}
          />
        </div>
        </div>}

        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.close"
              onClick={onClose}
              secondary
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.create" isLoading={submitting}>
              Create
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default LabelCreate
